export const navigateSchema = state => state.navigateSchema

export const appMenus = state => state.appMenus

export const systemMenus = state => state.systemMenus

export const basicInfo = state => state.basicInfo

export const personalMenus = state => state.personalMenus

export const tabMenus = state => state.tabMenus

export const navTabMenus = state => state.navTabMenus

export const activeTabMenu = state => state.activeTabMenu

export const AllBreadCrumbsMenu = state => state.AllBreadCrumbsMenu

export const userName = state => state.userName

export const extendData = state => state.extendData

export const tags = state => state.tags

export const todoMenuId = state => state.todoMenuId

export const messageMenuId = state => state.messageMenuId

export const viewType = state => state.viewType
